import React, { useState, useEffect, useCallback } from 'react';
import { Input, Icon, Tooltip, message, Alert } from 'antd';
import Loader from '../../components/Loader';
import Button from '../../components/Button';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import { fetchAPIKey, regenerateAPIKey } from '../../utils/services/authAPI';
import { FullPageLoaderContainer } from '../../artboard/styles';
import { Header, Main } from '../MailRoom/styles';
import { InputContainer, InputLabel } from '../UserSettingsPage/styles';
import { Container } from './styles';
import { withTranslation } from 'react-i18next';
import { INTEGRATION_KEY as trans } from './TranslationValues';
const NAMESPACES = ['INTEGRATION_KEY'];

const SaasIntegrationKey = props => {
  const [apiKey, setApiKey] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRegenerating, setIsRegenerating] = useState(false);
  const { t } = props;

  useEffect(() => {
    // The API key is retrieved.
    retrieveAPIKey();
  }, []);

  const retrieveAPIKey = async () => {
    setIsLoading(true);
    const res = await fetchAPIKey();
    if (res && res.statusCode === 1915 && res.errors.length === 0) {
      setApiKey(res.data.apiKey);
    }
    setIsLoading(false);
  };

  // Function to regenerate the API key.
  const regenerateApiKey = async () => {
    setIsRegenerating(true);
    const res = await regenerateAPIKey();
    if (res && res.statusCode === 1917 && res.errors.length === 0) {
      message.success(
        t(trans.REGENERATED_SUCCESS_MESSAGE.key, trans.REGENERATED_SUCCESS_MESSAGE.value),
      );
      setConfirmationModal(false);
      retrieveAPIKey();
    }
    setIsRegenerating(false);
  };

  // This function copies the API key to the clipboard.
  const copyApiKey = useCallback(() => {
    navigator.clipboard.writeText(apiKey);
    message.success(t(trans.COPIED_SUCCESS_MESSAGE.key, trans.COPIED_SUCCESS_MESSAGE.value));
  }, [apiKey]);

  return (
    <Main>
      <Container>
        <Header height={'20vh'}>
          <h2 className="title">
            {t(trans.INTEGRATION_KEY_TITLE.key, trans.INTEGRATION_KEY_TITLE.value)}
          </h2>
        </Header>

        {/* A loading indicator will be shown while the API is being processed; otherwise, the component will be rendered. */}
        {isLoading ? (
          <FullPageLoaderContainer>
            <Loader text={t(trans.LOADING_TEXT.key, trans.LOADING_TEXT.value) + '...'} />
          </FullPageLoaderContainer>
        ) : (
          <InputContainer className="input-container">
            <InputLabel className="input-label">
              {t(trans.API_KEY_LABEL.key, trans.API_KEY_LABEL.value)}
            </InputLabel>
            <Alert
              description={t(
                trans.REGENERATION_WARNING_MESSAGE.key,
                trans.REGENERATION_WARNING_MESSAGE.value,
              )}
              type="warning"
              showIcon
            />
            <Input
              name="licenseKey"
              size="large"
              readOnly={true}
              value={apiKey}
              addonAfter={
                <Tooltip
                  title={t(trans.COPY_CLIPBOARD_TOOLTIP.key, trans.COPY_CLIPBOARD_TOOLTIP.value)}
                  trigger="hover"
                >
                  <div className="copy-button" onClick={() => copyApiKey()}>
                    <Icon type={'copy'} />{' '}
                    <p>{t(trans.COPY_BUTTON.key, trans.COPY_BUTTON.value)}</p>
                  </div>
                </Tooltip>
              }
            />
            <Button
              className="custom-button"
              label={t(trans.REGENERATE_BUTTON.key, trans.REGENERATE_BUTTON.value)}
              large={true}
              onClick={() => setConfirmationModal(true)}
            />

            {/* The confirmation of API Key regeneration is accomplished through the use of this modal. */}
            <ConfirmationModal
              showImage={false}
              visibility={confirmationModal}
              onCancel={() => setConfirmationModal(false)}
              onConfirm={() => regenerateApiKey()}
              confirmationText={t(
                trans.REGENERATE_CONFIRMATION_MESSAGE.key,
                trans.REGENERATE_CONFIRMATION_MESSAGE.value,
              )}
              confirmButtonText={
                isRegenerating
                  ? t(trans.REGENERATING_BUTTON.key, trans.REGENERATING_BUTTON.value)
                  : t(trans.PROCEED_BUTTON.key, trans.PROCEED_BUTTON.value)
              }
              isLoading={isRegenerating}
            />
          </InputContainer>
        )}
      </Container>
    </Main>
  );
};

export default withTranslation(NAMESPACES)(SaasIntegrationKey);
